const { code, empty, dateTime } = require('./booking-detail')
const { deadlineInput, deadlinePayload } = require('./booking-manual-actions')

const reservationRoles = ['hotel_manager', 'hotel_reservations', 'reservation_supervisor', 'reservation_assistant', 'general_manager']
const deadlineFields = ['payment_time_limit', 'ticketing_time_limit']
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

function hasBookingEditRole(groups) {
  return Array.isArray(groups) && groups.some(group => reservationRoles.includes(group.code))
}

function canEditBookingBlock(booking, groups, block) {
  if (!booking || code(booking.booking_mode) !== 'manual' || !hasBookingEditRole(groups)) return false
  const status = code(booking.status)
  if (block === 'invoice') return true
  if (!['pending', 'partially_booked', 'held', 'confirmed', 'ticketed'].includes(status)) return false
  if (block === 'time-limits') return status !== 'ticketed'
  if (block === 'pnr') return true
  if (block !== 'ticket') return false
  if (status === 'ticketed') return true
  const manual = booking.manual_booking || {}
  return status === 'confirmed' && code(manual.request_status) === 'book' && code(manual.provider_status) === 'booked' && !empty(booking.pnr) && !booking.ticket
}

function bookingEditDraft(booking) {
  return {
    pnr: booking.pnr || '',
    payment_time_limit: deadlineInput(booking.payment_time_limit),
    ticketing_time_limit: deadlineInput(booking.ticketing_time_limit),
    ticket_number: booking.ticket_number || '',
    ticket: booking.ticket ? { ...booking.ticket } : {}
  }
}

function bookingEditPayload(block, draft, initial) {
  const payload = {}
  if (block === 'pnr') {
    const value = String(draft.pnr || '').trim()
    if (value !== String(initial.pnr || '').trim()) payload.pnr = value
  } else if (block === 'time-limits') {
    for (const field of deadlineFields) {
      if ((draft[field] || '') !== (initial[field] || '')) payload[field] = empty(draft[field]) ? null : deadlinePayload(draft[field])
    }
  } else if (block === 'ticket') {
    const value = String(draft.ticket_number || '').trim()
    if (value !== String(initial.ticket_number || '').trim()) payload.ticket_number = value || null
    if ((draft.ticket || {}).id !== (initial.ticket || {}).id && (draft.ticket || {}).id) payload.ticket = draft.ticket.id
  }
  return payload
}

function bookingEditErrors(block, draft, booking) {
  const errors = {}
  if (block === 'pnr') {
    const pnr = String(draft.pnr || '').trim()
    if (!pnr) errors.pnr = 'This field is required.'
    else if (pnr.length > 100) errors.pnr = 'PNR must be 100 characters or fewer.'
  } else if (block === 'time-limits') {
    for (const field of deadlineFields) {
      if (!empty(draft[field]) && !deadlinePayload(draft[field])) errors[field] = 'Enter a valid date and time.'
    }
    if (deadlineFields.every(field => empty(draft[field]))) errors.deadlines = 'Enter at least one deadline: payment or ticketing.'
  } else if (block === 'ticket') {
    if (String(draft.ticket_number || '').trim().length > 100) errors.ticket_number = 'Number must be 100 characters or fewer.'
    const ticketId = (draft.ticket || {}).id
    if (ticketId && !uuid.test(ticketId)) errors.ticket = 'Upload a valid ticket file.'
    else if (!ticketId && (code(booking.status) === 'confirmed' || booking.ticket)) errors.ticket = code(booking.status) === 'confirmed' ? 'Attach a ticket file.' : 'The saved ticket cannot be removed. Choose a replacement file.'
  }
  return errors
}

function bookingHistoryChanges(context) {
  const before = (context || {}).before || {}
  const after = (context || {}).after || {}
  const labels = { pnr: 'PNR', payment_time_limit: 'Payment · PTL', ticketing_time_limit: 'Ticketing · TTL', ticket_number: 'Ticket number', ticket: 'Ticket file' }
  return Object.keys(labels).filter(field => Object.prototype.hasOwnProperty.call(after, field) && before[field] !== after[field]).map(field => ({
    field,
    label: labels[field],
    before: field === 'ticket' ? before[field] ? 'Attached' : '—' : field.endsWith('_time_limit') ? dateTime(before[field]) || '—' : empty(before[field]) ? '—' : String(before[field]),
    after: field === 'ticket' ? after[field] ? before[field] ? 'Replaced' : 'Attached' : '—' : field.endsWith('_time_limit') ? dateTime(after[field]) || '—' : empty(after[field]) ? '—' : String(after[field])
  }))
}

module.exports = { hasBookingEditRole, canEditBookingBlock, bookingEditDraft, bookingEditPayload, bookingEditErrors, bookingHistoryChanges }
